import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Sort} from '@angular/material/sort';
import {OfficeService} from '../../Services/office.service';
import {HttpResponse} from '@angular/common/http';
import {MatPaginator} from '@angular/material/paginator';
import Swal from "sweetalert2";
import {Subject} from "rxjs";

interface PatientPagination {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

@Component({
  selector: 'pm-office-registration',
  templateUrl: './office-registration.component.html',
  styleUrls: ['./office-registration.component.css']
})
export class OfficeRegistrationComponent implements OnInit {


  tableData: any = [];
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  totalRecord: any;
  page: number = 1;
  size: number = 10;
  currentPage = 0;
  searchText: any;
  isSidebarExpanded = false;
  hidePassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  checked: boolean = false;
  officeIds: any = [];
  errorMessages: any;
  errorMessagePart: any;
  files: File[] = [];
  isDragOver: boolean = false;
  fileImage: string | null = null; // Variable to hold the image URL
  selectedPlanOption: string = '';
  selectedPlan: { [key: string]: string } = {};
  selectedPlanForIcon: string = '';
  private clientSub: any;
  private subject: Subject<string> = new Subject();

  pagination: PatientPagination = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };


  @ViewChild('resetPassword') resetPassModal!: ElementRef;

  @ViewChild('bulkUpload') bulkUploadModal!: ElementRef;
  @ViewChild('fileDropRef') fileDropRef!: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;


  constructor(private fb: FormBuilder,
              private clientServices: ClientService,
              private officeService: OfficeService,
              public authService: AuthService,
              private router: Router,
              private renderer: Renderer2,
              private el: ElementRef,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {

  }


  ngOnInit(): void {
    this.loadPaginationState(); // Remove pagination state on reload
    this._fetchData();
    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (clientId) {
        this.pagination.page = 1;
        this.pagination.currentPage = 0;
        this._fetchData();
      }
    });

    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('officePagination');
    });
    localStorage.setItem('officeIds', JSON.stringify(this.officeIds));
  }
  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageIndex = this.pagination.currentPage; // Restore page index
    }
  }

  onSelectPlan(value: string, id: number): void {
    this.selectedPlan[id] = value;
    // console.log(`Selected plan for ID ${id}: ${value}`);
  }

  onSelectPlanIcon(value: string): void {
    this.selectedPlanForIcon = value;
    // console.log('Selected plan (icon button):', value);
  }

  // Get Client data
  _fetchData(type?: any) {
    let params: { [key: string]: any } = {
      page: this.pagination.page,
      size: this.pagination.size,
      clientId: this.authService.getClientId() || null,
      isOfficeListing: true
    };

    if (type === 2) {
      params.active = true;
    } else if (type === 3) {
      params.active = false;
    }

    this.officeService.getAllOffices(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response) {
            this.tableData = response.content || [];
            this.totalRecord = response.totalElements || 0;

            if (this.paginator) {
              this.paginator.pageIndex = this.pagination.currentPage;
            }

            setTimeout(() => {
              this.cdr.detectChanges();
            }, 0);
          } else {
            this.tableData = [];
            this.totalRecord = 0;
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || response?.detail || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableData = [];
          this.totalRecord = 0;
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || '',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
  }

  // Search
  onKeyUp(searchTextValue: any): void {
    this.subject.next(searchTextValue);
  }

  handleKeyUp(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;

    // Trigger search on Enter
    if (event.key === 'Enter') {
      this.onKeyUp(this.searchText);
      return;
    }

    // Existing debounce logic
    this.subject.next(value);
  }
  clearSearch(input: HTMLInputElement) {
    input.value = '';
    /*this.searchString = '';*/
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this._fetchData(1);
  }


  assign(id?: any) {
    if (id === 'All') {
      if (this.checked) {
        // Uncheck all items
        this.officeIds = []; // Clear assignArray
        this.tableData.forEach(item => {
          item.assigned = false; // Set assigned to false for all
          delete item.assignedF; // Remove the assignedF property
        });
        this.checked = false;
      } else {
        // Assign all items
        this.officeIds = this.tableData.map(item => item.id); // Update assignArray with all IDs
        this.tableData.forEach(item => {
          item.assigned = true; // Set assigned to true for all
          item.assignedF = true; // Add assignedF property
        });
        this.checked = true;
      }
      localStorage.setItem('officeIds', JSON.stringify(this.officeIds));
    } else {
      const index = this.officeIds.indexOf(id);
      if (index === -1) {
        // Add ID if it's not in assignArray and set assigned to true
        this.officeIds.push(id);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = true;
          item.assignedF = true; // Add assignedF property to the specific item
        }
      } else {
        // Remove ID if it's already in assignArray
        this.officeIds.splice(index, 1);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = false;
          delete item.assignedF; // Remove the assignedF property from the specific item
        }
      }

      // Set checked to true only if all tableData IDs are in assignArray
      this.checked = this.tableData.every(item => this.officeIds.includes(item.id));
      localStorage.setItem('officeIds', JSON.stringify(this.officeIds));
    }
  }


  exportViewFile(officeId: string, baseFilename: string, planCreation:any) {
    const params = {
      officeId: officeId,
      planCreation : planCreation
    };

    this.clientServices.getClientTemplate(params).subscribe((response: HttpResponse<Blob>) => {
      const contentType = response.headers.get('Content-Type') || '';

      // Extract filename directly from Content-Disposition
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `${baseFilename}.pdf`; // fallback

      if (contentDisposition) {
        // For "attachment; filename=ADC Template.xlsx"
        const parts = contentDisposition.split('filename=');
        if (parts.length > 1) {
          filename = parts[1].trim();
          // Remove quotes if present
          if (filename.startsWith('"') && filename.endsWith('"')) {
            filename = filename.slice(1, -1);
          }
        }
      }

      // console.log('Filename:', filename);

      const blob = new Blob([response.body!], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);

      // Always download - regardless of file type
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 100);
    }, (error) => {
      console.error('File export error:', error);
    });
  }



  openModal() {
    const modalElement = this.bulkUploadModal.nativeElement;
    modalElement.style.display = 'flex'; // Center modal with flexbox
    modalElement.classList.add('show'); // Add the 'show' class for animation

    // Add blur to the background
    this.renderer.addClass(document.body, 'blur-background');
  }

  // Method to close the modal and remove background blur
  closeModal() {
    this.errorMessages = null;
    this.errorMessagePart = null;
    this.files = null;       // Optionally clear the file data as well
    this.fileImage = null;
    const modalElement = this.bulkUploadModal.nativeElement;
    modalElement.style.display = 'none'; // Hide modal
    modalElement.classList.remove('show'); // Remove 'show' class

    // Remove blur from the background
    this.renderer.removeClass(document.body, 'blur-background');
  }

  upload() {
    // Your upload logic here
    // console.log('Uploading...');
  }

  onFilesSelected(event: any): void {
    const selectedFiles = event.target.files;
    this.files = Array.from(selectedFiles);

    // Check if the first selected file is an Excel file
    if (this.files.length > 0) {
      const file = this.files[0];
      if (file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'text/csv' ||
        file.type === 'application/csv') {
        // Set the image for Excel files
        this.fileImage = 'assets/img/xlxs.png'; // Path to the image for Excel files
      } else {
        this.fileImage = null; // Reset if not an Excel file
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    const droppedFiles = event.dataTransfer?.files;
    if (droppedFiles) {
      this.files = Array.from(droppedFiles);
      this.fileDropRef.nativeElement.files = droppedFiles; // Set files in the input

      // Check if the dropped file is an Excel file
      const file = this.files[0];
      if (file && (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        this.fileImage = 'assets/img/xlxs.png'; // Path to the image for Excel files
      } else {
        this.fileImage = null; // Reset if not an Excel file
      }
    }
  }

  /*uploadFiles(): void {
      if (this.files.length) {
          const formData = new FormData();
          /!*let params = {
              clientId: this.authService.getClientId()
          };*!/

          // Append files
          for (let file of this.files) {
              formData.append('file', file, file.name);
          }

          // Append officeIds array as a JSON string
          formData.append('officeIds', JSON.stringify(this.officeIds));

          this.officeService.officeBulkUpload(formData).pipe(first()).subscribe(
              (response: any) => {
                  if (response) {
                      this._fetchData();
                      this.closeModal();
                      swal.fire({
                          icon: 'success',
                          text: 'Uploaded successfully.',
                          showConfirmButton: false,
                          timer: 3000
                      });
                  } else {
                      this.handleErrorResponse(response);
                  }
              },
              (error) => {
                  this.handleErrorResponse(error.error);
              }
          );
      }
  }*/

  /*uploadFiles(): void {
      if (!this.selectedPlanOption) {
          swal.fire({
              icon: 'warning',
              title: 'Missing Field',
              text: 'Please select a Plan Creation option before uploading.'
          });
          return;
      }

      if (this.files.length) {
          const formData = new FormData();

          for (let file of this.files) {
              formData.append('file', file, file.name);
          }

          this.officeIds.forEach(id => {
              formData.append('officeIds', id.toString());
          });

          formData.append('planCreation', this.selectedPlanOption);

          this.officeService.officeBulkUpload(formData).pipe(first()).subscribe(
              (response: any) => {
                  if (response) {
                      this._fetchData();
                      this.closeModal();
                      swal.fire({
                          icon: 'success',
                          text: 'Uploaded successfully.',
                          showConfirmButton: false,
                          timer: 3000
                      });
                  } else {
                      this.handleErrorResponse(response);
                  }
              },
              (error) => {
                  this.handleErrorResponse(error.error);
              }
          );
      }
  }*/
  uploadFiles(): void {
    if (!this.selectedPlanOption) {
      swal.fire({
        icon: 'warning',
        title: 'Missing Field',
        text: 'Please select a Plan Creation option before uploading.'
      });
      return;
    }

    if (this.files.length) {
      const formData = new FormData();

      // Append the file(s)
      for (let file of this.files) {
        formData.append('file', file, file.name);
      }

      // Correctly append request with content type set to application/json
      const requestPayload = {
        officeIds: this.officeIds,
        planCreation: this.selectedPlanOption
      };

      const jsonBlob = new Blob(
        [JSON.stringify(requestPayload)],
        { type: 'application/json' }
      );

      formData.append('request', jsonBlob);  // use Blob, not string

      this.officeService.officeBulkUpload(formData).pipe(first()).subscribe(
        (response: any) => {
          if (response) {
            this._fetchData();
            this.officeIds = [];
            this.closeModal();
            swal.fire({
              icon: 'success',
              text: 'Uploaded successfully.',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            this.handleErrorResponse(response);
          }
        },
        (error) => {
          this.handleErrorResponse(error.error);
        }
      );
    }
  }

  deleteEntry(officeId: any) {

    let reqData = {
      officeId
    };
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this record ?',
      icon: 'warning',
      iconColor: 'red',
      showCancelButton: true,
      confirmButtonText: 'Yes !'
    }).then((result) => {
      if (result.isConfirmed) {
        this.officeService.deleteOffice(reqData).pipe(first()).subscribe(
          (response: any) => {
            if (response?.success) {
              this._fetchData(1);
              swal.fire({
                icon: 'success',
                text: `Provider Deleted successfully.`,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: 'Something went wrong!',
                showConfirmButton: false,
                timer: 2000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: 'Failed to communicate with the server!',
              showConfirmButton: false,
              timer: 2000
            });
          });
      }
    });
  }

  handleErrorResponse(error: any): void {
    const errorMessage = error?.message;
    const errorArray = error?.errors;

    // Case 1: Error with 'errors' array (structured validation errors)
    if (errorArray && Array.isArray(errorArray)) {
      this.errorMessagePart = errorMessage || 'Validation errors occurred';
      this.errorMessages = errorArray.map((e: any) => e.message || 'Unknown validation error');
    }
    // Case 2: Error message with "Details:"
    else if (errorMessage && errorMessage.includes('Details:')) {
      const {messagePart, detailsPart} = this.extractErrorDetails(errorMessage);
      this.errorMessagePart = messagePart;
      this.errorMessages = detailsPart;
    }
    // Fallback: Just a plain message
    else if (errorMessage) {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Fallback : string
    else if (typeof errorMessage === 'string') {
      this.errorMessagePart = errorMessage;
      this.errorMessages = [];
    }
    // Last fallback
    else {
      this.errorMessagePart = 'An error occurred';
      this.errorMessages = [];
    }
  }

  extractErrorDetails(message: string): { messagePart: string, detailsPart: string[] } {
    const detailsStart = message.indexOf('Details:');

    if (detailsStart === -1) {
      return {messagePart: message.trim(), detailsPart: []};
    }

    // Split the main message and the detailed part
    const messagePart = message.substring(0, detailsStart).trim();
    const detailsString = message.substring(detailsStart + 8).trim();

    const detailsPart: string[] = [];

    // Match all nested brackets: [row: 1, ...], [row: 2, ...]
    const nestedDetailMatches = detailsString.match(/\[(.*?)\]/g); // Match all [ ... ] groups

    if (nestedDetailMatches) {
      nestedDetailMatches.forEach(detail => {
        const cleanDetail = detail
          .replace(/^\[|\]$/g, '') // remove outer brackets
          .trim();
        if (cleanDetail) {
          detailsPart.push(cleanDetail);
        }
      });
    } else {
      // Fallback if no brackets are found: split by comma
      detailsPart.push(...detailsString.split(',').map(d => d.trim()));
    }

    return {messagePart, detailsPart};
  }

  removeImage(): void {
    this.errorMessages = null;
    this.errorMessagePart = null;
    this.files = null;       // Optionally clear the file data as well
    this.fileImage = null;  // Clear the image source
  }


  pageChange(event: any) {
    this.pagination.currentPage = event.pageIndex;
    this.pagination.page = this.pagination.currentPage + 1;
    this.pagination.size = event.pageSize;

    sessionStorage.setItem('officePagination', JSON.stringify(this.pagination));

    this._fetchData(); // Fetch data using selectedType
  }

  loadPaginationState() {
    const storedData = sessionStorage.getItem('officePagination');

    if (storedData) {
      this.pagination = JSON.parse(storedData);

    }
  }

  // Sort form frontend logic
  sortData(sort: Sort) {
    const data = this.tableData.slice();
    if (!sort.active || sort.direction === '') {
      this.tableData = data;
      return;
    }

    this.tableData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'email':
          return compare(a.email, b.email, isAsc);
        case 'contact':
          return compare(a.contact, b.contact, isAsc)
        case 'address':
          return compare(a.address, b.address, isAsc);
        case 'status':
          return compare(a.status, b.status, isAsc);
        default:
          return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
